import { render, staticRenderFns } from "./ClientOrganization.vue?vue&type=template&id=0627c233&"
import script from "./ClientOrganization.vue?vue&type=script&lang=ts&"
export * from "./ClientOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports